import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardScheduleContext = createContext(null);

// declare provider component
const CardScheduleProvider = ({ children }) => {

  const [schedule, setSchedule] = useState(null);
  const [scheduleVisibleMonth, setScheduleVisibleMonth] = useState(new Date());
  const [scheduleLoading, setScheduleLoading] = useState(null);
  const [scheduleError, setScheduleError] = useState(null);
  const [scheduleSelectedDate, setScheduleSelectedDate] = useState(null);



  const setTheSchedule = (schedule) => {
    if (logComponent('CardScheduleContext')) { console.debug('CardScheduleContext setTheSchedule'); }
    let newSchedule = schedule ? [ ...schedule ] : null;
    setSchedule(newSchedule);
  }

  const setTheScheduleVisibleMonth = (scheduleVisibleMonth) => {
    if (logComponent('CardScheduleContext')) { console.debug('CardScheduleContext setTheScheduleVisibleMonth'); }
    let newScheduleVisibleMonth = scheduleVisibleMonth;
    setScheduleVisibleMonth(newScheduleVisibleMonth);
  }

  const setTheScheduleLoading = (scheduleLoading) => {
    if (logComponent('CardScheduleContext')) { console.debug('CardScheduleContext setTheScheduleLoading'); }
    let newScheduleLoading = scheduleLoading;
    setScheduleLoading(newScheduleLoading);
  }

  const setTheScheduleError = (scheduleError) => {
    if (logComponent('CardScheduleContext')) { console.debug('CardScheduleContext setTheScheduleError'); }
    let newScheduleError = scheduleError;
    setScheduleError(newScheduleError);
  }

  const setTheScheduleSelectedDate = (scheduleSelectedDate) => {
    if (logComponent('CardScheduleContext')) { console.debug('CardScheduleContext setTheScheduleSelectedDate'); }
    let newScheduleSelectedDate = scheduleSelectedDate;
    setScheduleSelectedDate(newScheduleSelectedDate);
  }


  const cardState = useMemo(() => ({
    schedule,
    scheduleVisibleMonth,
    scheduleLoading,
    scheduleError,
    scheduleSelectedDate,
    setSchedule: setTheSchedule,
    setScheduleVisibleMonth: setTheScheduleVisibleMonth,
    setScheduleLoading: setTheScheduleLoading,
    setScheduleError: setTheScheduleError,
    setScheduleSelectedDate: setTheScheduleSelectedDate
  }), [
    schedule,
    scheduleVisibleMonth,
    scheduleLoading,
    scheduleError,
    scheduleSelectedDate
]);

  return (
    <CardScheduleContext.Provider value={ cardState }>
      {children}
    </CardScheduleContext.Provider>
  );
}

// export provider and context
export { CardScheduleContext, CardScheduleProvider };